var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"10px"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"1"}}),_c('b-col',{attrs:{"sm":"12","lg":"8"}},[_c('work-subject',{attrs:{"p_showDetails":{'type': 'all', 'subject_name': ''}}})],1),_c('b-col',{attrs:{"sm":"12","lg":"3"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }